var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{attrs:{"false-value":false,"true-value":true},model:{value:(_vm.localItem),callback:function ($$v) {_vm.localItem=$$v},expression:"localItem"}})}
var staticRenderFns = []

export { render, staticRenderFns }